const PandasJson = [
    {
  "id": 1,
  "html_title": "intro",
  "bootstrap_head_desc": [
    {
"bootstrap_title_heading": "What is Pandas?",
"bootstrap_title_desc": `Pandas is a Python library for working with structured data like tables (rows and columns). It helps you organize, clean, and analyze data easily.

It’s very popular in data analysis, data science, and machine learning.`
    },
    {
"bootstrap_title_heading": "Installing Pandas",
"bootstrap_title_desc": `To install Pandas, open your terminal or command prompt and type:

pip install pandas`
    },
    {
"bootstrap_title_heading": "Importing Pandas",
"bootstrap_title_desc": `After installing, you can import Pandas in your Python file like this:

import pandas as pd

We use 'pd' as a short name to save typing.`
    },
    {
"bootstrap_title_heading": "What is a Series?",
"bootstrap_title_desc": `A Series is like a one-dimensional list with labels.

Example:
import pandas as pd
s = pd.Series([10, 20, 30])
print(s)

Output:
0    10
1    20
2    30

The numbers on the left are called the index.`
    },
    {
"bootstrap_title_heading": "What is a DataFrame?",
"bootstrap_title_desc": `A DataFrame is like a table with rows and columns.

Example:
import pandas as pd
data = {'Name': ['Alice', 'Bob'], 'Age': [25, 30]}
df = pd.DataFrame(data)
print(df)

Output:
    Name  Age
0  Alice   25
1    Bob   30`
    },
    {
"bootstrap_title_heading": "Basic Example (Create and Display DataFrame)",
"bootstrap_title_desc": `import pandas as pd

data = {'City': ['New York', 'Paris', 'London'], 'Population': [8.4, 2.1, 8.9]}
df = pd.DataFrame(data)
print(df)

Output:
 City  Population
0  New York   8.4
1     Paris   2.1
2    London   8.9`
    }
  ],
  "coursename": "Intro to Pandas"
}


  ,  
  
  {
    "id": 2,
    "html_title": "creating-inspecting-dataframes",
    "bootstrap_head_desc": [
{
  "bootstrap_title_heading": "Creating DataFrames from a Dictionary",
  "bootstrap_title_desc": `import pandas as pd  
  data = {'Name': ['Alice', 'Bob', 'Charlie'], 'Age': [25, 30, 35], 'City': ['NY', 'LA', 'Chicago']}  
  df = pd.DataFrame(data)  
  print(df)
  
  Output:
  Name  Age    City  
  0    Alice   25NY  
  1Bob   30LA  
  2  Charlie   35  Chicago`
},
{
  "bootstrap_title_heading": "Reading Data from CSV and Excel",
  "bootstrap_title_desc": `Read from CSV:
  df = pd.read_csv('data.csv')  
  print(df.head())
  
  Read from Excel:
  df = pd.read_excel('data.xlsx')  
  print(df.head())
  
  Example CSV (data.csv):
  Name,Age,City  
  Alice,25,NY  
  Bob,30,LA  
  Charlie,35,Chicago`
},
{
  "bootstrap_title_heading": "Using head() and tail()",
  "bootstrap_title_desc": `df.head() → Shows first 5 rows  
  df.tail() → Shows last 5 rows
  
  Example:
  print(df.head(2)) → First 2 rows  
  print(df.tail(1)) → Last row`
},
{
  "bootstrap_title_heading": "Getting Data Overview with info() and describe()",
  "bootstrap_title_desc": `info():
  print(df.info())
  
  Example Output:
  <class 'pandas.core.frame.DataFrame'>  
  RangeIndex: 3 entries, 0 to 2  
  Data columns (total 3 columns):  
  Name 3 non-null object  
  Age 3 non-null int64  
  City 3 non-null object
  
  describe():
  print(df.describe())
  
  Example Output:
   Age  
  count   3.000000  
  mean   30.000000  
  std     5.000000  
  min    25.000000  
  max    35.000000`
},
{
  "bootstrap_title_heading": "Checking Data Types and Shape",
  "bootstrap_title_desc": `print(df.dtypes) → Data types of each column
  
  Example Output:
  Name    object  
  Ageint64  
  City    object
  
  print(df.shape) → (3, 3) → 3 rows, 3 columns`
}
    ],
    "coursename": "Creating & Inspecting DataFrames"
  }
    ,
    
    {
  "id": 3,
  "html_title": "indexing-selection",
  "bootstrap_head_desc": [
    {
"bootstrap_title_heading": "Selecting Columns",
"bootstrap_title_desc": `You can select a column from a DataFrame using square brackets or dot notation.
    
    Example:
    \`\`\`python
    import pandas as pd
    data = {
  'Name': ['Alice', 'Bob', 'Charlie'],
  'Age': [25, 30, 35],
  'City': ['Delhi', 'Mumbai', 'Bangalore']
    }
    df = pd.DataFrame(data)
    
    print(df['Age'])# Preferred
    print(df.Name)  # Works only if no space or special char in column name
    \`\`\``
    },
    {
"bootstrap_title_heading": "Selecting Multiple Columns",
"bootstrap_title_desc": `To get multiple columns, pass a list of column names inside double brackets.
    
    Example:
    \`\`\`python
    df[['Name', 'City']]
    \`\`\``
    },
    {
"bootstrap_title_heading": "Selecting Rows with loc[]",
"bootstrap_title_desc": `Use .loc[] to select rows by label (index name). You can also filter specific columns.
    
    Example:
    \`\`\`python
    # Single row by index label
    df.loc[0]
    
    # Row + specific column
    df.loc[1, 'City']
    
    # Multiple rows and columns
    df.loc[0:2, ['Name', 'City']]
    \`\`\`\`
    },
    {
"bootstrap_title_heading": "Selecting Rows with iloc[]",
"bootstrap_title_desc": \`Use .iloc[] to select rows and columns by integer position (starting from 0).
    
    Example:
    \`\`\`python
    df.iloc[0]  # First row
    df.iloc[1:3]# Row 1 and 2
    df.iloc[:, 1]     # All rows, second column
    df.iloc[0, 2]     # First row, third column
    \`\`\`\`
    },
    {
"bootstrap_title_heading": "Faster Access with at[] and iat[]",
"bootstrap_title_desc": \`Use these for faster scalar access (single value):
    
    Example:
    \`\`\`python
    df.at[1, 'City']     # Like loc but faster for single value
    df.iat[2, 0]   # Like iloc but faster for single value
    \`\`\`\`
    },
    {
"bootstrap_title_heading": "Conditional Filtering",
"bootstrap_title_desc": \`You can filter rows using conditions.
    
    Example:
    \`\`\`python
    df[df['Age'] > 28]    # Filter where Age is greater than 28
    df[df['City'] == 'Delhi']   # Filter rows from Delhi
    \`\`\`
    
    You can also combine conditions:
    \`\`\`python
    df[(df['Age'] > 25) & (df['City'] == 'Mumbai')]
    \`\`\`
    
    Note: Use parentheses around conditions and & (and), | (or) operators.`
    }
  ],
  "coursename": "Indexing & Selection"
},

   
  {
    "id": 4,
    "html_title": "missing-data",
    "bootstrap_head_desc": [
{
  "bootstrap_title_heading": "Detecting Missing Data",
  "bootstrap_title_desc": `Pandas uses NaN (Not a Number) to represent missing values.

You can detect missing values using:
\`\`\`python
import pandas as pd
import numpy as np

data = {
    'Name': ['Alice', 'Bob', 'Charlie', None],
    'Age': [25, np.nan, 30, 28],
    'City': ['Delhi', 'Mumbai', None, 'Bangalore']
}
df = pd.DataFrame(data)

df.isnull() # Shows True where data is missing
df.notnull()# Shows True where data is present
df.isnull().sum() # Count missing values in each column
\`\`\``
},
{
  "bootstrap_title_heading": "Filling Missing Data",
  "bootstrap_title_desc": `You can fill missing values using fillna().

Examples:
\`\`\`python
df.fillna('Unknown')# Fill all NaNs with 'Unknown'
df['Age'].fillna(0) # Fill missing Age with 0
df['Age'].fillna(df['Age'].mean())  # Fill Age with average
\`\`\`

You can also fill forward or backward:
\`\`\`python
df.fillna(method='ffill')  # Fill forward from previous row
df.fillna(method='bfill')  # Fill backward from next row
\`\`\``
},
{
  "bootstrap_title_heading": "Replacing Specific Values",
  "bootstrap_title_desc": `If your dataset uses a special value (e.g. -999 or "N/A") to mean missing, you can replace them:

\`\`\`python
df.replace('N/A', np.nan, inplace=True)
df.replace(-999, np.nan, inplace=True)
\`\`\``
},
{
  "bootstrap_title_heading": "Dropping Missing Data",
  "bootstrap_title_desc": `You can remove rows or columns that contain NaN using dropna().

Examples:
\`\`\`python
df.dropna()   # Drop all rows with any missing value
df.dropna(axis=1)   # Drop columns with any missing value
df.dropna(thresh=2) # Keep rows with at least 2 non-null values
\`\`\``
},
{
  "bootstrap_title_heading": "Practical Example",
  "bootstrap_title_desc": `\`\`\`python
data = {
    'Name': ['John', 'Anna', None],
    'Score': [85, None, 90],
    'Grade': ['A', None, 'B']
}
df = pd.DataFrame(data)

# Count missing
print(df.isnull().sum())

# Fill missing Score with mean
df['Score'].fillna(df['Score'].mean(), inplace=True)

# Drop rows where Name is missing
df.dropna(subset=['Name'], inplace=True)
\`\`\``
}
    ],
    "coursename": "Data Cleaning: Missing Data"
  },


  {
"id": 5,
"html_title": "duplicates-and-dtypes",
"bootstrap_head_desc": [
  {
    "bootstrap_title_heading": "Detecting and Removing Duplicates",
    "bootstrap_title_desc": `Duplicates occur when rows have identical values in all or selected columns.
  
  You can find and remove duplicates like this:
  \`\`\`python
  import pandas as pd
  
  data = {
'Name': ['Alice', 'Bob', 'Alice', 'David'],
'Age': [25, 30, 25, 40]
  }
  df = pd.DataFrame(data)
  
  df.duplicated()   # Detects duplicate rows (returns True/False)
  df.duplicated().sum()   # Count how many duplicates
  df.drop_duplicates()    # Removes duplicate rows
  df.drop_duplicates(subset=['Name'])  # Remove based on only 'Name'
  \`\`\``
  },
  {
    "bootstrap_title_heading": "Changing Data Types with astype()",
    "bootstrap_title_desc": `Data types affect how operations behave. Use astype() to convert column types.
  
  Examples:
  \`\`\`python
  df['Age'] = df['Age'].astype(float)     # Convert to float
  df['Age'] = df['Age'].astype('int')     # Convert to integer
  df['Age'] = df['Age'].astype('str')     # Convert to string
  \`\`\`
  
  Check current data types:
  \`\`\`python
  df.dtypes
  \`\`\``
  },
  {
    "bootstrap_title_heading": "Converting Strings to DateTime",
    "bootstrap_title_desc": `If you have dates as strings, convert them to datetime format:
  
  \`\`\`python
  df['JoinDate'] = pd.to_datetime(df['JoinDate'])
  \`\`\`
  
  This enables date filtering, sorting, and resampling.
  `
  },
  {
    "bootstrap_title_heading": "Renaming Columns and Index",
    "bootstrap_title_desc": `To rename columns or index labels:
  
  \`\`\`python
  df.rename(columns={'Name': 'FullName'}, inplace=True)
  df.rename(index={0: 'row1', 1: 'row2'}, inplace=True)
  \`\`\`
  
  To rename all column names at once:
  \`\`\`python
  df.columns = ['FullName', 'Age']
  \`\`\``
  },
  {
    "bootstrap_title_heading": "Practical Example",
    "bootstrap_title_desc": `\`\`\`python
  data = {
'Name': ['Anna', 'Bob', 'Anna'],
'Score': ['85', '90', '85'],
'Joined': ['2021-01-01', '2021-02-15', '2021-01-01']
  }
  df = pd.DataFrame(data)
  
  # Remove duplicate rows
  df = df.drop_duplicates()
  
  # Convert Score to integer
  df['Score'] = df['Score'].astype(int)
  
  # Convert Joined column to datetime
  df['Joined'] = pd.to_datetime(df['Joined'])
  
  # Rename columns
  df.rename(columns={'Name': 'StudentName'}, inplace=True)
  \`\`\``
  }
],
"coursename": "Data Cleaning: Duplicates & Data Types"
    },


    {
"id": 6,
"html_title": "data-transformation",
"bootstrap_head_desc": [
  {
    "bootstrap_title_heading": "Applying Functions: apply() and map()",
    "bootstrap_title_desc": `You can apply custom or built-in functions to transform data.
  
  🔸 apply() → works on Series or DataFrames  
  🔸 map() → works only on Series (especially useful for replacing values)
  
  Examples:
  \`\`\`python
  import pandas as pd
  
  df = pd.DataFrame({
'Name': ['Alice', 'Bob', 'Charlie'],
'Score': [85, 90, 95]
  })
  
  # Use apply() to convert scores to grades
  def to_grade(score):
if score >= 90:
    return 'A'
elif score >= 80:
    return 'B'
else:
    return 'C'
  
  df['Grade'] = df['Score'].apply(to_grade)
  
  # Use map() to shorten names
  df['ShortName'] = df['Name'].map({'Alice': 'A', 'Bob': 'B', 'Charlie': 'C'})
  \`\`\``
  },
  {
    "bootstrap_title_heading": "Sorting Data",
    "bootstrap_title_desc": `Sort rows by column values using sort_values()
  
  \`\`\`python
  df.sort_values(by='Score') # Ascending
  df.sort_values(by='Score', ascending=False)  # Descending
  df.sort_values(by=['Grade', 'Score'])  # Sort by multiple columns
  \`\`\`
  
  Sort by index:
  \`\`\`python
  df.sort_index()
  \`\`\``
  },
  {
    "bootstrap_title_heading": "Ranking Values",
    "bootstrap_title_desc": `You can assign ranks to numerical values using rank()
  
  \`\`\`python
  df['Rank'] = df['Score'].rank(ascending=False)
  \`\`\`
  
  Rank will give 1 to the highest score.
  `
  },
  {
    "bootstrap_title_heading": "Changing Column Order",
    "bootstrap_title_desc": `To change the order of columns:
  
  \`\`\`python
  df = df[['Name', 'Score', 'Grade', 'Rank']]
  \`\`\`
  
  You can reorder columns manually or by logic.
  `
  },
  {
    "bootstrap_title_heading": "Practical Example",
    "bootstrap_title_desc": `\`\`\`python
  data = {
'Product': ['Pen', 'Notebook', 'Pencil'],
'Price': [5, 20, 3],
'Units Sold': [100, 50, 200]
  }
  df = pd.DataFrame(data)
  
  # Add a column for Total Revenue
  df['Revenue'] = df['Price'] * df['Units Sold']
  
  # Add a column for Revenue Category using apply()
  df['Category'] = df['Revenue'].apply(lambda x: 'High' if x >= 1000 else 'Low')
  
  # Sort by Revenue
  df = df.sort_values(by='Revenue', ascending=False)
  
  # Rearranged columns
  df = df[['Product', 'Price', 'Units Sold', 'Revenue', 'Category']]
  \`\`\``
  }
],
"coursename": "Data Transformation"
    },




    
{
  "id": 7,
  "html_title": "aggregation-grouping",
  "bootstrap_head_desc": [
    {
"bootstrap_title_heading": "What is Grouping and Aggregation?",
"bootstrap_title_desc": `Pandas lets you group data by column values and then perform calculations (aggregations) like sum, mean, count, etc.
    
    → groupby() is used to split data into groups  
    → Then we apply functions like sum(), mean(), count(), etc.
    `
    },
    {
"bootstrap_title_heading": "Basic groupby Example",
"bootstrap_title_desc": `\`\`\`python
    import pandas as pd
    
    df = pd.DataFrame({
  'Department': ['Sales', 'Sales', 'HR', 'HR', 'IT'],
  'Employee': ['Alice', 'Bob', 'Charlie', 'David', 'Eve'],
  'Salary': [50000, 55000, 48000, 52000, 60000]
    })
    
    # Group by Department and calculate total salary
    grouped = df.groupby('Department')['Salary'].sum()
    print(grouped)
    \`\`\`
    
    🡆 Output:
    \`\`\`
    Department
    HR  100000
    IT   60000
    Sales     105000
    \`\`\``
    },
    {
"bootstrap_title_heading": "Using Multiple Aggregation Functions",
"bootstrap_title_desc": `You can use multiple aggregation functions at once:
    
    \`\`\`python
    df.groupby('Department')['Salary'].agg(['mean', 'max', 'min'])
    \`\`\`
    
    This gives average, highest, and lowest salary per department.
    `
    },
    {
"bootstrap_title_heading": "Group by Multiple Columns",
"bootstrap_title_desc": `You can group by more than one column:
    
    \`\`\`python
    df = pd.DataFrame({
  'Team': ['A', 'A', 'B', 'B', 'A'],
  'Gender': ['M', 'F', 'M', 'F', 'F'],
  'Score': [90, 85, 88, 92, 80]
    })
    
    df.groupby(['Team', 'Gender'])['Score'].mean()
    \`\`\`
    
    🡆 This returns the average score for each Team + Gender combination.
    `
    },
    {
"bootstrap_title_heading": "Resetting the Index",
"bootstrap_title_desc": `groupby() results usually return grouped columns as index.
    
    To turn them back into normal columns:
    
    \`\`\`python
    result = df.groupby('Department')['Salary'].sum().reset_index()
    \`\`\``
    },
    {
"bootstrap_title_heading": "Practical Example: Sales Summary",
"bootstrap_title_desc": `\`\`\`python
    sales = pd.DataFrame({
  'Region': ['East', 'West', 'East', 'West', 'East'],
  'Product': ['Pen', 'Pen', 'Notebook', 'Notebook', 'Pen'],
  'Revenue': [100, 200, 150, 250, 120]
    })
    
    # Total revenue by Region
    sales.groupby('Region')['Revenue'].sum()
    
    # Total revenue by Region and Product
    sales.groupby(['Region', 'Product'])['Revenue'].sum().reset_index()
    \`\`\`
    
    🡆 This helps summarize large data into readable insights.
    `
    }
  ],
  "coursename": "Aggregation & Grouping"
},


{
  "id": 8,
  "html_title": "merging-joining-concatenation",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "Combining DataFrames in Pandas",
      "bootstrap_title_desc": `Pandas provides powerful tools to combine datasets:

→ merge() — SQL-style joins on columns
→ join() — combines based on index or key
→ concat() — stacks DataFrames vertically or horizontally`
    },
    {
      "bootstrap_title_heading": "Using merge()",
      "bootstrap_title_desc": `
\`\`\`python
import pandas as pd

left = pd.DataFrame({
  'ID': [1, 2, 3],
  'Name': ['Alice', 'Bob', 'Charlie']
})

right = pd.DataFrame({
  'ID': [2, 3, 4],
  'Score': [85, 90, 95]
})

# Inner join on ID
result = pd.merge(left, right, on='ID')
print(result)
\`\`\`

🡆 Output:
\`\`\`
 ID     Name  Score
0   2      Bob     85
1   3  Charlie     90
\`\`\`
`
    },
    {
      "bootstrap_title_heading": "Types of Joins in merge()",
      "bootstrap_title_desc": `
→ inner (default): keeps only matching rows
→ outer: keeps all rows, fills missing with NaN
→ left: all rows from left DataFrame
→ right: all rows from right DataFrame

\`\`\`python
# Outer join
pd.merge(left, right, on='ID', how='outer')
\`\`\`
`
    },
    {
      "bootstrap_title_heading": "Using join()",
      "bootstrap_title_desc": `
join() is similar to merge(), but works on index by default.

\`\`\`python
left = pd.DataFrame({
  'Score': [85, 90, 95]
}, index=['Alice', 'Bob', 'Charlie'])

right = pd.DataFrame({
  'Grade': ['A', 'B', 'A']
}, index=['Alice', 'Bob', 'Charlie'])

# Join on index
combined = left.join(right)
print(combined)
\`\`\`
`
    },
    {
      "bootstrap_title_heading": "Using concat()",
      "bootstrap_title_desc": `
concat() is used to stack DataFrames:
→ axis=0: vertical stacking
→ axis=1: horizontal joining

\`\`\`python
df1 = pd.DataFrame({'A': [1, 2], 'B': [3, 4]})
df2 = pd.DataFrame({'A': [5, 6], 'B': [7, 8]})

pd.concat([df1, df2], axis=0)
\`\`\`
`
    },
    {
      "bootstrap_title_heading": "Practical Example: Student Records",
      "bootstrap_title_desc": `
\`\`\`python
students = pd.DataFrame({
  'ID': [1, 2, 3],
  'Name': ['Alice', 'Bob', 'Charlie']
})

scores = pd.DataFrame({
  'ID': [1, 2, 3],
  'Math': [80, 75, 90],
  'Science': [88, 70, 95]
})

# Merge student info with scores
merged = pd.merge(students, scores, on='ID')
print(merged)
\`\`\`

🡆 This helps in combining different datasets into a unified view.
`
    }
  ],
  "coursename": "Merging, Joining, and Concatenation"
},


{
  "id": 9,
  "html_title": "datetime-resample",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "Working with Dates & Times in Pandas",
      "bootstrap_title_desc": `Handling datetime data is important when working with time series, logs, sales trends, etc.

→ Pandas uses the datetime64 type for handling dates and times
→ pd.to_datetime() is used to convert strings to datetime objects
→ DatetimeIndex enables time-based operations`
    },
    {
      "bootstrap_title_heading": "Converting Strings to Datetime",
      "bootstrap_title_desc": `Use pd.to_datetime() to convert text to proper datetime objects:

\`\`\`python
import pandas as pd

dates = pd.Series(['2024-01-01', '2024-01-05', '2024-01-10'])
converted = pd.to_datetime(dates)
print(converted)
\`\`\`

🡆 Output:
\`\`\`
0   2024-01-01
1   2024-01-05
2   2024-01-10
Name: Dates, dtype: datetime64[ns]
\`\`\``
    },
    {
      "bootstrap_title_heading": "Extracting Date Parts",
      "bootstrap_title_desc": `You can extract year, month, day, etc. from a datetime column:

\`\`\`python
df = pd.DataFrame({
  'Date': pd.to_datetime(['2024-01-01', '2024-02-15', '2024-03-30'])
})
df['Year'] = df['Date'].dt.year
df['Month'] = df['Date'].dt.month
df['Day'] = df['Date'].dt.day
\`\`\``
    },
    {
      "bootstrap_title_heading": "Filtering by Date",
      "bootstrap_title_desc": `Datetime columns allow easy filtering:

\`\`\`python
mask = df['Date'] > '2024-02-01'
print(df[mask])
\`\`\`
🡆 This filters rows after Feb 1st, 2024.`
    },
    {
      "bootstrap_title_heading": "Resampling Time Series Data",
      "bootstrap_title_desc": `Resampling allows you to change frequency (e.g. daily → monthly).
You must set the datetime column as the index first:

\`\`\`python
df = pd.DataFrame({
  'Date': pd.date_range('2024-01-01', periods=10, freq='D'),
  'Sales': [100, 120, 90, 150, 80, 200, 170, 160, 130, 110]
})
df.set_index('Date', inplace=True)

# Resample to weekly sales
weekly = df.resample('W').sum()
print(weekly)
\`\`\`

🡆 Output will show total sales per week.`
    },
    {
      "bootstrap_title_heading": "Practical Example: Website Visits by Month",
      "bootstrap_title_desc": `
\`\`\`python
visits = pd.DataFrame({
  'Date': pd.date_range(start='2024-01-01', periods=100, freq='D'),
  'Visitors': [x * 10 for x in range(1, 101)]
})
visits.set_index('Date', inplace=True)

# Total visitors per month
monthly_visits = visits.resample('M').sum()
print(monthly_visits)
\`\`\`
🡆 Helps visualize trends over time.
`
    }
  ],
  "coursename": "Working with Dates & Times"
},


{
  "id": 10,
  "html_title": "pivot-crosstab",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "What is a Pivot Table in Pandas?",
      "bootstrap_title_desc": "Pivot tables help reshape and summarize data — similar to Excel.\n\n→ pd.pivot_table() is used to create pivot tables\n→ pd.crosstab() summarizes frequency counts"
    },
    {
      "bootstrap_title_heading": "Creating a Pivot Table",
      "bootstrap_title_desc": "```python\nimport pandas as pd\n\ndf = pd.DataFrame({\n    'Department': ['HR', 'HR', 'IT', 'IT', 'Sales'],\n    'Gender': ['M', 'F', 'M', 'F', 'F'],\n    'Salary': [50000, 52000, 60000, 58000, 55000]\n})\n\npivot = pd.pivot_table(df, values='Salary', index='Department', columns='Gender', aggfunc='mean')\nprint(pivot)\n```"
    },
    {
      "bootstrap_title_heading": "Using Crosstab",
      "bootstrap_title_desc": "```python\npd.crosstab(df['Department'], df['Gender'])\n```\n\n🡆 Gives count of males and females in each department."
    },
    {
      "bootstrap_title_heading": "MultiIndex in Pivot Table",
      "bootstrap_title_desc": "You can use multiple columns as index:\n\n```python\npd.pivot_table(df, values='Salary', index=['Department', 'Gender'], aggfunc='mean')\n```"
    },
    {
      "bootstrap_title_heading": "Practical Example: Sales by Region and Product",
      "bootstrap_title_desc": "```python\nsales = pd.DataFrame({\n    'Region': ['East', 'East', 'West', 'West'],\n    'Product': ['Pen', 'Notebook', 'Pen', 'Notebook'],\n    'Revenue': [100, 150, 200, 250]\n})\n\npivot = pd.pivot_table(sales, values='Revenue', index='Region', columns='Product', aggfunc='sum')\nprint(pivot)\n```"
    }
  ],
  "coursename": "Pivot Tables & Crosstabs"
}
,


{
  "id": 11,
  "html_title": "pandas-visualization",
  "bootstrap_head_desc": [
  {
  "bootstrap_title_heading": "Introduction to Visualization in Pandas",
  "bootstrap_title_desc": "Pandas integrates with Matplotlib to create basic plots easily. You can generate line charts, bar plots, histograms, scatter plots, and more using the .plot() method directly on Series or DataFrames."
  },
  {
  "bootstrap_title_heading": "Basic Line Plot",
  "bootstrap_title_desc": "python\nimport pandas as pd\nimport matplotlib.pyplot as plt\n\nsales = pd.Series([100, 120, 150, 170], index=['Q1', 'Q2', 'Q3', 'Q4'])\nsales.plot(kind='line', title='Quarterly Sales')\nplt.ylabel('Revenue')\nplt.show()\n"
  },
  {
  "bootstrap_title_heading": "Bar Plot Example",
  "bootstrap_title_desc": "python\nsales_data = pd.DataFrame({\n 'Product': ['Pen', 'Notebook', 'Eraser'],\n 'Sales': [150, 200, 80]\n})\nsales_data.set_index('Product')['Sales'].plot(kind='bar', title='Product Sales')\nplt.ylabel('Units Sold')\nplt.show()\n"
  },
  {
  "bootstrap_title_heading": "Scatter Plot",
  "bootstrap_title_desc": "python\ndf = pd.DataFrame({\n 'Hours_Studied': [1, 2, 3, 4, 5],\n 'Score': [50, 55, 65, 70, 80]\n})\ndf.plot(kind='scatter', x='Hours_Studied', y='Score', title='Study Time vs Score')\nplt.show()\n"
  },
  {
  "bootstrap_title_heading": "Histogram",
  "bootstrap_title_desc": "python\nages = pd.Series([22, 25, 27, 25, 30, 35, 40, 22, 28])\nages.plot(kind='hist', bins=5, title='Age Distribution')\nplt.xlabel('Age')\nplt.show()\n"
  },
  {
  "bootstrap_title_heading": "Styling Your Plots",
  "bootstrap_title_desc": "You can customize your plots using color, grid, figsize, legend, and more.\n\nExample:\npython\nsales.plot(kind='line', color='green', linestyle='--', marker='o', grid=True, figsize=(8, 4))\nplt.title('Styled Sales Chart')\nplt.show()\n"
  }
  ],
  "coursename": "Visualization with Pandas"
  },

  {
    "id": 12,
    "html_title": "real-world-project",
    "bootstrap_head_desc": [
    {
    "bootstrap_title_heading": "Overview: Real-World Project",
    "bootstrap_title_desc": "In this final day, you'll combine everything you’ve learned into an end-to-end mini project using Pandas.\n\nWe'll perform:\n→ Data cleaning\n→ Analysis & grouping\n→ Visualization\n→ Saving the results"
    },
    {
    "bootstrap_title_heading": "Dataset Example: Online Store Orders",
    "bootstrap_title_desc": "python\nimport pandas as pd\nimport matplotlib.pyplot as plt\n\norders = pd.DataFrame({\n 'OrderID': [1, 2, 3, 4, 5, 6],\n 'Product': ['Pen', 'Notebook', 'Pen', 'Pencil', 'Pen', 'Notebook'],\n 'Quantity': [2, 1, 4, 3, 1, 2],\n 'Price': [5, 15, 5, 3, 5, 15],\n 'Region': ['East', 'West', 'East', 'East', 'West', 'West']\n})\n\norders['Total'] = orders['Quantity'] * orders['Price']\n"
    },
    {
    "bootstrap_title_heading": "Step 1: Cleaning & Checking Data",
    "bootstrap_title_desc": "python\norders.info()\norders.isnull().sum()\n"
    },
    {
    "bootstrap_title_heading": "Step 2: Analyzing Data",
    "bootstrap_title_desc": "→ Total sales per region:\npython\nregion_sales = orders.groupby('Region')['Total'].sum()\nprint(region_sales)\n\n→ Most sold product:\npython\nproduct_sales = orders.groupby('Product')['Quantity'].sum()\nprint(product_sales)\n"
    },
    {
    "bootstrap_title_heading": "Step 3: Visualization",
    "bootstrap_title_desc": "python\nregion_sales.plot(kind='bar', title='Sales by Region')\nplt.ylabel('Total Revenue')\nplt.show()\n\nproduct_sales.plot(kind='pie', autopct='%1.1f%%', title='Product Share')\nplt.show()\n"
    },
    {
    "bootstrap_title_heading": "Step 4: Performance Tips",
    "bootstrap_title_desc": "→ Avoid df.iterrows() in most cases (slow)\n→ Use vectorized operations:\npython\norders['Total'] = orders['Quantity'] * orders['Price'] # Fast & efficient\n"
    },
    {
    "bootstrap_title_heading": "Step 5: Saving Results",
    "bootstrap_title_desc": "Save summary to CSV, Excel, and JSON:\npython\nregion_sales.to_csv('region_sales.csv')\nproduct_sales.to_excel('product_sales.xlsx')\norders.to_json('orders.json', orient='records')\n"
    }
    ],
    "coursename": "Real-World Project & Best Practices"
    }



,


  
    ];
    export default PandasJson;
    